export default __webpack_public_path__ + "static/WeatherAppHome-208a7e9bd2fc4532124c4ed073959356.png";